import { render, staticRenderFns } from "./TeamGoalFinishInfo.vue?vue&type=template&id=bb78eabe&scoped=true"
import script from "./TeamGoalFinishInfo.vue?vue&type=script&lang=js"
export * from "./TeamGoalFinishInfo.vue?vue&type=script&lang=js"
import style0 from "./TeamGoalFinishInfo.vue?vue&type=style&index=0&id=bb78eabe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb78eabe",
  null
  
)

export default component.exports